import { z } from 'zod';
/**
 * 한 오버레이 kind에 동시에 살아 있을 수 있는 비밀 슬롯이다.
 * 값은 배열이 런타임과 타입의 유일한 원천이다. 유니온을 먼저 쓰지 않는다.
 *
 * - `1`: 주소1. 첫 발급·기존 단일 토큰 행이 앉는 자리이다.
 * - `2`: 주소2. 라이브 로테이션에서 비어 있는 쪽에 민트한다.
 */
export const OVERLAY_TOKEN_SLOTS = [1, 2];
const overlayTokenSlotLiterals = OVERLAY_TOKEN_SLOTS.map((slot) => z.literal(slot));
const overlayTokenSlotFirst = overlayTokenSlotLiterals[0];
const overlayTokenSlotSecond = overlayTokenSlotLiterals[1];
if (overlayTokenSlotFirst === undefined || overlayTokenSlotSecond === undefined) {
    throw new Error('OVERLAY_TOKEN_SLOTS must contain at least two members');
}
/**
 * HTTP·계약 검증용 슬롯 스키마다. `OVERLAY_TOKEN_SLOTS`를 `z.literal`로 펼친다.
 * 숫자 닫힌 집합이라 Zod 3의 `z.enum`은 쓰지 않는다.
 */
export const overlayTokenSlotSchema = z.union([
    overlayTokenSlotFirst,
    overlayTokenSlotSecond,
    ...overlayTokenSlotLiterals.slice(2),
]);
/** 값이 `OVERLAY_TOKEN_SLOTS`에 있는지 본다. 손 유니온 `1 | 2`와 비교하지 않는다. */
export function isOverlayTokenSlot(value) {
    return typeof value === 'number' && OVERLAY_TOKEN_SLOTS.includes(value);
}
//# sourceMappingURL=overlay-token-slot.schema.js.map